@use 'sass:map';

@use '../../../scss/global/spacing';
@use '../../../scss/global/color';

@use './link.vars.scss' as *;
@use './link.mixins' as mixins;

:host {
  display: inline-flex;

  .fds-link {
    &__link {
      display: flex;
      position: relative;
      white-space: nowrap;
      align-items: center;
      border-bottom-width: spacing.$spacer-0-5;
      border-bottom-style: solid;

      @include mixins.link-text;

      &:hover {
        background-color: var(--background-color-default-hover);
        cursor: pointer;
        color: var(--text-color-hover);
      }

      &:focus {
        color: var(--text-color-focus);
        outline: 2px solid var(--fds-color-common-blue100, color.$default-blue-100);
      }

      &--white {
        color: var(--text-color-white);

        &:hover {
          background-color: var(--background-color-white-hover);
          color: var(--text-color-white);
        }

        &:focus {
          color: var(--text-color-white);
        }
      }
    }

    &__icon {
      width: 1rem;
      height: 1rem;
      padding: 0 0 spacing.$spacer-2 spacing.$spacer-1;
    }
  }
}
